import React from "react";

interface KpiCardProps {
  label: string;
  value: string;
  warning?: boolean;
  hero?: boolean;
}

export function KpiCard({ label, value, warning, hero }: KpiCardProps) {
  if (hero) {
    return (
      <div className="rounded-[10px] border border-primary bg-primary p-4">
        <p className="text-sm text-primary-soft">{label}</p>
        <p className="mt-2 text-2xl font-semibold text-white">{value}</p>
      </div>
    );
  }

  return (
    <div className="rounded-[10px] border border-border-subtle bg-surface p-4">
      <p className="text-sm text-slate-500">{label}</p>
      <p
        className={`mt-2 text-2xl font-semibold ${
          warning ? "text-red-600" : "text-slate-800"
        }`}
      >
        {value}
      </p>
    </div>
  );
}
